module.exports = __webpack_public_path__ + "public/Icons/6Manageadmins.svg?9720e1fa";